import React from "react";
import CrudModule, { StatusBadge } from "@/components/CrudModule";
import { fmtDate } from "@/lib/api";

export default function Employees() {
  return (
    <CrudModule
      title="Employees"
      subtitle="Profiles, departments, licenses & payroll."
      endpoint="employees"
      testid="employees"
      columns={[
        { key: "name", label: "Name" },
        { key: "role", label: "Role" },
        { key: "department", label: "Department" },
        { key: "phone", label: "Phone", mono: true },
        { key: "license", label: "Driver License" },
        { key: "status", label: "Status", render: (v) => <StatusBadge value={v} /> },
        { key: "hire_date", label: "Hired", render: (v) => fmtDate(v) },
      ]}
      fields={[
        { key: "name", label: "Full Name", full: true },
        { key: "role", label: "Role" },
        { key: "department", label: "Department", type: "select", options: ["Management", "Administration", "Logistics", "Sales", "Warehouse"] },
        { key: "phone", label: "Phone" },
        { key: "license", label: "Driver License" },
        { key: "salary", label: "Salary (BZ$)", type: "number" },
        { key: "status", label: "Status", type: "select", options: ["active", "inactive"] },
        { key: "hire_date", label: "Hire Date", type: "date" },
      ]}
    />
  );
}
